import React,{Suspense, useState, useEffect} from 'react';
import {Route, Routes, Navigate, useLocation} from 'react-router-dom';
import TopBarProgress from 'react-topbar-progress-indicator';
import DeveloperLayout from '../../_template/layout/DeveloperLayout';
// import {
//     Home, 
//     Channels,
//     Concepts,
//     ManageVirtualAgent,
//     Overview,
//     Deployments,
//     BestPractices
// } from '../pages/admin/botSetup/BotSetupMenu';

import Agents from '../pages/admin/agents/Agents';
import Overview from '../pages/admin/guide/overview/Overview';
import Concepts from '../pages/admin/guide/concepts/Concepts';
import Channels from '../pages/admin/guide/channels/Channels';

import ManageVirtualAgent from '../pages/admin/manageAgent/ManageVirtualAgent';

import Deployments from '../pages/admin/guide/deployments/Deployments';
import BestPractices from '../pages/admin/guide/bestPractices/BestPractices';
import TruChatWidget from '../pages/admin/guide/truChatWidget/TruChatWidget';
import { CdrReport, MissedChat } from '../pages/admin/report';


import DevProfile from '../pages/developer/profile/DevProfile';

const SuspensedView = ({children}) => {
    const location = useLocation();
    const [progress, setProgress] = useState(true);
    TopBarProgress.config({
        barColors: {
            "0": '#f61616',
        },
        barThickness: 2,
        shadowBlur: 5,
    });
    useEffect(() => {
        setProgress(true);
        const timer = setTimeout(() => setProgress(false), 500);
        return () => clearTimeout(timer);
    }, [location]);
    return (
        <>
            {progress && <TopBarProgress />}
            <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
        </>
    );
}

const DeveloperRoutes = () => {
    return (
        <>
            <Routes>
                <Route element={<DeveloperLayout />}>
                    <Route index element={<Navigate to='/agents' />} />
              
                    <Route path='/agents' element={
                        <SuspensedView>
                            <Agents />
                        </SuspensedView>
                    } />
                    <Route path='/guide/overview' element={
                        <SuspensedView>
                            <Overview />
                        </SuspensedView>
                    } />
                    <Route path='/guide/concepts' element= {
                        <SuspensedView>
                            <Concepts />
                        </SuspensedView>
                    }/>
                    <Route 
                        path='/virtual-agent' 
                        element={
                            <SuspensedView>
                                <ManageVirtualAgent />
                            </SuspensedView>
                        }
                    />
                    <Route 
                        path='/virtual-agent/:param_bot_id' 
                        element={
                            <SuspensedView>
                                <ManageVirtualAgent />
                            </SuspensedView>
                        }
                    />
                    <Route path='/guide/channels' element={
                        <SuspensedView>
                            <Channels />
                        </SuspensedView>
                    }/>
                    <Route path='/guide/deployments' element={
                        <SuspensedView>
                            <Deployments />
                        </SuspensedView>
                    }/>
                    <Route path='/guide/best-practices' element={
                        <SuspensedView>
                            <BestPractices />
                        </SuspensedView>
                    }/>
                    <Route path='/guide/tru-chatwidget' element={
                        <SuspensedView>
                            <TruChatWidget />
                        </SuspensedView>
                    }/>
                    <Route path='/report/cdr-report' element={
                        <SuspensedView>
                            <CdrReport />
                        </SuspensedView>
                    }/>
                    <Route path='/report/missed-chat' element={
                        <SuspensedView>
                            <MissedChat />
                        </SuspensedView>
                    }/>
                    <Route path='/profile' element={
                        <SuspensedView>
                            <DevProfile />
                        </SuspensedView>
                    }/>
                </Route>
                <Route path='*' element={<Navigate to="/error" />} />
            </Routes>
        </>
    )
}

export default DeveloperRoutes